<script lang="ts">
  // The interface sits behind Cloudflare Access. Requests that arrive
  // without the Cf-Access-Authenticated-User-Email header are bounced
  // by the proxy Worker; in dev the X-Dev-Identity header substitutes
  // for it. If a request reaches the interface without an identity,
  // either Cloudflare Access is misconfigured (production) or the
  // dev identity switcher needs a selection (local).
  //
  // A user from an allowed domain whose corporate email is not yet in
  // data/access-control.json reaches this page (the "Welcome — your
  // access is being provisioned" state per INTERFACE-SPECIFICATION.md
  // §13.2). An admin (Andrew, Greg) is notified to add them via PR.

  import { identity } from '../lib/identity.svelte';

  const isDev = import.meta.env.DEV;
</script>

<section class="card">
  {#if identity.not_provisioned}
    <h2>Welcome</h2>
    <p>
      Your corporate email reached the maintenance interface but is not yet listed in the access register.
      An administrator has been notified to provision your access.
    </p>
    <p class="muted">
      Once an administrator merges the access-register change, refresh this page. Your roles will appear in the header and the views you can act on will become visible.
    </p>
  {:else}
    <h2>Authentication required</h2>
    <p>
      This interface is reached through Cloudflare Access. Your request did not carry an authenticated identity header.
    </p>
    {#if isDev}
      <p class="muted">
        In local development, choose a dev identity from the header dropdown. The proxy Worker accepts the
        <code>X-Dev-Identity</code> header in place of Cloudflare Access when <code>DEV_MODE</code> is enabled.
      </p>
    {:else}
      <p class="muted">
        Refresh the page; Cloudflare Access should redirect you to corporate sign-in. If the redirect does not appear, ask an administrator to verify the Access application configuration.
      </p>
    {/if}
  {/if}
</section>
